import { useEffect } from "react";
import { withModal } from "../../contexts/ModalContext";
import { openLanguageModal } from "../../services/modalService";
import i18n from "i18next";
import axios from "../../Http";
import { initReactI18next } from "react-i18next";
import { availableLanguages, getBestMatchFromCodesWithoutFallback, languageDetector, setActiveLanguage, } from "../../i18n";
import I18NextHttpBackend from "i18next-http-backend/cjs";
document.body.classList.add("i18n-loading");
const i18nInitialization = i18n
    .use(languageDetector)
    .use(I18NextHttpBackend)
    .use(initReactI18next)
    .init({
    supportedLngs: Object.keys(availableLanguages),
    fallbackLng: ["nl"],
    debug: false,
    ns: ["common"],
    defaultNS: "common",
    fallbackNS: ["common", "dossier", "fine_dossier"],
    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: "/lang/{{lng}}/{{ns}}.json?v=" + process.env.MIX_CACHE_BREAKER,
    },
    react: {
        useSuspense: false,
    },
});
const LanguageRoot = ({ showModal }) => {
    const onInitialized = () => {
        const found = languageDetector.detect();
        if (!getBestMatchFromCodesWithoutFallback(found)) {
            setActiveLanguage("nl");
            if (Object.keys(availableLanguages).length > 1) {
                openLanguageModal(showModal);
            }
        }
        document.body.classList.remove("i18n-loading");
        axios.defaults.headers.common["Accept-Language"] = i18n.language;
    };
    useEffect(() => {
        if (!i18n.isInitialized) {
            i18nInitialization.then(onInitialized).catch(onInitialized);
        }
        else {
            onInitialized();
        }
    }, []);
    return null;
};
export default withModal(LanguageRoot);
